import Button from "../../../../../ui/molecules/button";
import { Spinner } from "../../../../../ui/molecules/spinner";
import { ContactStateEnum } from "../../../dto";

export function PrivacyVerified({ onClose, listIndex, isLoading, handleConfirm }: {
    onClose: () => void, listIndex: number, isLoading: boolean
    handleConfirm: (outcome: ContactStateEnum, outcomeInfo: string | null) => void;
}) {
    return (
        <>
            <p className="text-text-md font-medium text-neutral-600 text-center max-w-md">
                Consenso alla Privacy verificato.
                <br />
                Cliccando su <span className="font-bold text-neutral-800">"Conferma"</span> prenderai in carico il lead.
                <br />
                <br />
            </p>
            <div className="flex w-3/4 items-center gap-4">
                <div className="flex-1">
                    <Button size={"sm"} iconPosition={"left"} variant={"outline"} color={"gray"} label="Annulla" onClick={() => { onClose() }} fullWidth />
                </div>
                {
                    isLoading ?
                        <div className="flex-1 flex items-center justify-center">
                            <Spinner color="green" size={32} />
                        </div> :
                        <div className="flex-1">
                            <Button size={"sm"} iconPosition={"left"} variant={"solid"} color={"green"} label="Conferma" fullWidth
                                onClick={() => handleConfirm(ContactStateEnum.LEADTAKEN, null)}
                            />
                        </div>
                }
            </div>
        </>
    );
}
